const Footer = ({ theme }) => (
  <footer className={theme === 'dark' ? 'bg-gray-900 text-gray-200 mt-12' : 'bg-gray-50 text-gray-800 mt-12'}>
    <div className="max-w-4xl mx-auto py-8 px-4 text-center">
      <p>&copy; {new Date().getFullYear()} AI Transparency Project.</p>
      <p className={theme === 'dark' ? 'text-sm text-gray-400 mt-2' : 'text-sm text-gray-600 mt-2'}>
        Fostering a more transparent and equitable future of work.
      </p>
    </div>
  </footer>
);

export default Footer;